export default {
    getGocardless: (state) => state.gocardless,
};
